import { Input } from "../../components/core/Input";
import { useForm, UseFormRegister } from "react-hook-form";
import Stepper from "../../components/core/Stepper/Stepper"
import { PrimaryButton } from "../../components/others/ButtonPrimary";
import { InputEmail } from "../../components/others/InputEmail";

type InputPropType = {
  register: UseFormRegister<any>;
  errors?: any;
};



const StepOne = (stepperInterface: any) => {
  return (
    <div className="mt-5 mb-5 flex flex-col w-6/12 gap-3">
      <p>Step 1</p>
      <input
          type="text"
          placeholder="Nombre y Apellido"
          required
        />
        <input
          type="text"
          placeholder="E-mail"
          name="email"
          required
        />
    <div className="flex">
      <PrimaryButton type="button" text="Next" onClick={stepperInterface.nextStep} styles="bg-red-500 font-bold text-white w-auto"/>
    </div>
    </div>
  );
}

const StepTwo = (stepperInterface: any) => {
  return (
    <div className="mt-5 mb-5 flex flex-col w-6/12 gap-3">
      <p>Step 2</p>
      <input
          type="text"
          placeholder="Nombre y Apellido"
          required
        />
        <input
          type="text"
          placeholder="E-mail"
          name="email"
          required
        />
    <div className="flex">
      <PrimaryButton type="button" text="Back" onClick={stepperInterface.prevStep} styles="bg-red-500 font-bold text-white w-auto" />
      <PrimaryButton type="button" text="Next" onClick={stepperInterface.nextStep} styles="bg-red-500 font-bold text-white w-auto"/>
    </div>
    </div>
  );
}

const StepThree = (stepperInterface: any) => {
  return (
    <div className="mt-5 mb-5 flex flex-col w-6/12 gap-3">
      <p>Step 3</p>
      <input
          type="text"
          placeholder="Nombre y Apellido"
          required
        />
        <input
          type="text"
          placeholder="E-mail"
          name="email"
          required
        />
    <div className="flex">
      <PrimaryButton type="button" text="Back" onClick={stepperInterface.prevStep} styles="bg-red-500 font-bold text-white w-auto" />
      <PrimaryButton type="button" text="Next" onClick={stepperInterface.nextStep} styles="bg-red-500 font-bold text-white w-auto"/>
    </div>
    </div>
  );
}

export const steps = [
  { Component: StepOne, title: "Uno" },
  { Component: StepTwo, title: "Dos" },
  { Component: StepThree, title: "Tres" },
];

export default function FormsDemo() {
  return (
    <Stepper steps={steps}/>
  )
}
